/**
 * Deixa o nome do arquivo seguro para virar chave no Supabase Storage.
 *
 * O Storage valida a chave com `\w`, que é ASCII puro: um nome como
 * "Orçamento - Sanduiche.pdf" é recusado com `Invalid key`. Trocamos acentos
 * pelo equivalente sem acento e o resto por `_`, preservando a extensão.
 * O nome original segue sendo usado para exibição e para o download.
 */
export const sanitizeStorageFileName = (fileName: string): string => {
  const sanitizeSegment = (value: string) =>
    value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9._-]/g, '_')
      .replace(/_+/g, '_')
      .replace(/^_|_$/g, '');

  const lastDotIndex = fileName.lastIndexOf('.');
  const name = lastDotIndex > 0 ? fileName.substring(0, lastDotIndex) : fileName;
  const extension = lastDotIndex > 0 ? fileName.substring(lastDotIndex) : '';

  return (sanitizeSegment(name) || 'file') + sanitizeSegment(extension);
};
